// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 305) return "static/305.2.0.0-2026-S21.0.css";
	// return url for filenames based on template
	return undefined;
};